import React from 'react';
import ListPageLayout from '@layouts/ListPageLayout';

import UserFilterForm from './UserFilterForm';
import UserListTable from './UserListTable';
import UserModal from './UserModal';
import { filter_store, ItemStore} from '@store/User/UserList/UserStore';
import breadcrumb_store from '@src/Store/Common/MyBreadcrumb';
import login_user_store from '@src/Store/LoginUser/LoginUserStore';

class UserList extends React.PureComponent {

  constructor(props) {
    super();


    let state = props.location.state;
    let id = props.match.params.id;
    let type = props.match.params.type;
    let username = props.match.params.username;

    this.updateDatas(state, type, id, username);
  }

  componentWillReceiveProps(props) {
    let state = props.location.state;
    let id = props.match.params.id;
    let type = props.match.params.type;
    let username = props.match.params.username;

    this.updateDatas(state, type, id, username);
  }

  updateDatas(state, type, id, username) {
    if (state == undefined) {
    }
    else {
      filter_store.setAttr(state)
    }

    if (type == ItemStore.Type_Normal) {
      breadcrumb_store.resetUser(type, id, username);
    }
    else {
      if (id == login_user_store.id) {
        breadcrumb_store.resetUser(type, id, username);
      }
      else {
        breadcrumb_store.addUserItem(type, id, username);
      }
    }
  }

  render() {
    return (
      <ListPageLayout
        isCustomHeader
        header={
          <UserFilterForm/>
        }
        list={
          <UserListTable/>
        }
        modal={
          <UserModal/>
        }
      />
    );
  }
}

export default UserList;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/User/UserList/UserList.jsx